import { isEmpty, pick, each } from "lodash";
import fp from "lodash/fp";

import { filtersConstants } from "./filters.constants";

export const filtersActions = {
	reset,
	applyFilters,
	removeKey,
	setIsExported,
};

function reset(form: string, excludedLabels?: string[]) {
	return {
		type: filtersConstants.RESET_FILTERS,
		form,
		excludedLabels,
	};
}

function applyFilters({
	form,
	filters,
	columns,
	strictResetEmptyFilterValues,
}: {
	form: string;
	filters: { [key: string]: any };
	columns?: any[];
	strictResetEmptyFilterValues?: string[];
}) {
	const notEmptyObjectFilters = () => {
		if (strictResetEmptyFilterValues) {
			const getObjectFilterProperty = pick(
				filters,
				strictResetEmptyFilterValues,
			);

			const filterObjectResult = () => {
				if (!isEmpty(getObjectFilterProperty)) {
					return each(getObjectFilterProperty, (value, key) => {
						if (value) {
							const getObjectFilterValues = Object.entries(
								value,
							).filter(([key, value]) => value !== "");
							if (!isEmpty(getObjectFilterValues)) {
								getObjectFilterProperty[key] =
									Object.fromEntries(getObjectFilterValues);
							} else return (getObjectFilterProperty[key] = null);
						} else {
							getObjectFilterProperty[key] = null;
						}
					});
				} else return {};
			};
			return filterObjectResult();
		} else return {};
	};

	const notEmptyFilters = fp.pickBy(fp.identity, {
		...filters,
		...notEmptyObjectFilters(),
	});
	return {
		type: filtersConstants.APPLY_FILTERS,
		filters: notEmptyFilters,
		form,
		columns: columns,
	};
}

function setIsExported(form, isExported) {
	return {
		type: filtersConstants.SET_IS_EXPORTED,
		form,
		isExported,
	};
}

function removeKey(
	form,
	key,
	columns: any = [],
	index: any = undefined,
	predicate: any = undefined,
) {
	return {
		type: filtersConstants.REMOVE_KEY,
		form,
		key,
		columns,
		index,
		predicate,
	};
}
